import Model from 'src/app/common/model';

export default class TestCategoryModel extends Model {
  name: string;
  abbreviation?: string;
  description?: string;
  created_name: string;
  updated_name: string;

  constructor() {
    super();
  }
}
